// src/data/debateFormatsData.js
import {
  HiArrowsRightLeft,
  HiUsers,
  HiChatBubbleLeftRight,
  HiMiniRectangleGroup ,
  HiAcademicCap,
  HiUserGroup,
  HiBriefcase,
  HiPresentationChartLine,
  HiQuestionMarkCircle,
  HiChatBubbleBottomCenter,
  HiSpeakerWave,
  HiCube,
} from 'react-icons/hi2';

export const debateTypes = [
  // 1?? 1 vs 1
  {
    id: '1v1',
    title: '1 vs 1',
	icon: HiArrowsRightLeft,
	sample: 'A vs B',
    description: 'Classic head-to-head debate between two speakers, focusing on clarity and argumentation.',
    role: 'none',
    roles: { judge:{ exists:false, can:['updateScores','declareWinner'], fallbackFlowControl:false }, moderator:{ exists:false, can:['startDebate','endTurn','pauseDebate','resumeDebate'] } },
    participants:{ min:2,max:2 },
    teams:['A','B'],
    teamsnumber:[1,1],
    spectators:{ canParticipate:true, features:['comments', 'preVote', 'postVote'] },
    standardRules:['Present arguments clearly','Respond to opponent','Judge scores persuasiveness'],
    roleResponsibilities:['Score arguments','Declare winner'],
    turns:[
      { round:1, id:'a-opening', name:'Opening Statement', description:'Introduce your position clearly. Present 2-3 key arguments with evidence. Be persuasive, concise, and logical.', team:'A', durationSec:180, type:'speech' },
      { round:1, id:'b-opening', name:'Opening Statement', description:'Introduce your stance clearly. Outline your main arguments, provide evidence, and set the stage for rebuttal.', team:'B', durationSec:180, type:'speech' },
      { round:1, id:'a-rebuttal', name:'Rebuttal', description:'Directly address opponent\'s arguments, point out flaws, reinforce your main points. Focus on clarity and logical structure.', team:'A', durationSec:180, type:'rebuttal' },
      { round:1, id:'b-rebuttal', name:'Final Rebuttal', description:'Counter opponent rebuttals, summarize key strengths of your position, and aim for a compelling close.', team:'B', durationSec:180, type:'rebuttal' }
    ],
	faqs: [
	  { question: 'Is this a formal debate?', answer: 'It can be informal or structured depending on rules applied.' },
	  { question: 'Who wins the debate?', answer: 'A judge or audience typically decides the winner.' }
	]
  },

  // 2?? Lincoln-Douglas (LD)
  {
    id: 'ld',
    title: 'Lincoln-Douglas',
    sample: 'Philosophical duel: Aff vs Neg',
    icon: HiAcademicCap,
    description: '1v1 values-based debate with structured constructive and rebuttal speeches.',
    role: 'judge',
    roles: { judge:{ exists:true, can:['updateScores','declareWinnerr'], fallbackFlowControl:true }, moderator:{ exists:false, can:['startDebate','endTurn'] } },
    participants:{ min:2,max:2 },
    teams:['Aff','Neg'],
    teamsnumber:[1,1],
    spectators:{ canParticipate:false, features:['comments'] },
    standardRules:['Constructive ? Rebuttal ? Summary','Focus on values','Judge evaluates reasoning and persuasiveness'],
    roleResponsibilities:['Score arguments and reasoning','Declare winner'],
    turns:[
      { round:1, id:'aff-constructive', name:'Aff Constructive', description:'Present your value framework, define key terms, and introduce 2-3 contentions supported by evidence. Build a logical and persuasive foundation.', team:'Aff', durationSec:480, type:'speech' },
      { round:1, id:'neg-constructive', name:'Neg Constructive', description:'Respond to affirmative value framework, critique arguments, and introduce counterpoints with evidence. Be clear and structured.', team:'Neg', durationSec:480, type:'speech' },
      { round:1, id:'aff-rebuttal', name:'Aff Rebuttal', description:'Address negative points, highlight logical flaws, and reinforce your arguments. Be concise and persuasive.', team:'Aff', durationSec:240, type:'rebuttal' },
      { round:1, id:'neg-rebuttal', name:'Neg Rebuttal', description:'Respond to affirmative rebuttals, strengthen your case, and emphasize why your position is stronger within the value framework.', team:'Neg', durationSec:240, type:'rebuttal' },
      { round:1, id:'aff-summary', name:'Aff Summary', description:'Summarize your main points, highlight key strengths, and make a compelling close.', team:'Aff', durationSec:120, type:'reply' },
      { round:1, id:'neg-summary', name:'Neg Summary', description:'Summarize key counterarguments and persuasively conclude your case.', team:'Neg', durationSec:120, type:'reply' }
    ],
	faqs: [
	  { question: 'What is the focus of Lincoln–Douglas debate?', answer: 'Values, ethics, and philosophical arguments.' },
	  { question: 'Is evidence important?', answer: 'Yes, but logical reasoning and value frameworks are key.' }
	]
  },

  // 3?? Cross-Examination (Short)
  {
    id: 'cx',
    title: 'Cross-Examination',
    icon: HiQuestionMarkCircle,
    sample: '2 vs 2 + Cross-examination',
    description: 'Team debate with direct questioning; emphasizes rapid argument interaction.',
    role: 'judge',
    roles: { judge:{ exists:true, can:['updateScores','declareWinner'], fallbackFlowControl:true }, moderator:{ exists:false, can:['startDebate','endTurn','skipSpeaker'] } },
    participants:{ min:4,max:4 },
    teams:['Pro','Con'],
    teamsnumber:[2,2],
    spectators:{ canParticipate:false, features:['comments'] },
    standardRules:['Questions should be direct','Answers concise','Judge scores clarity and interaction'],
    roleResponsibilities:['Score interactions','Evaluate clarity and responsiveness'],
    turns:[
      { round:1, id:'pro-constructive', name:'Pro Constructive', description:'Present your main arguments, clearly define your stance, and support points with evidence. Be persuasive and structured.', team:'Pro', durationSec:180, type:'speech' },
      { round:1, id:'cx-by-con', name:'Cross-Examination', description:'Ask targeted questions to challenge Pro\'s claims. Focus on inconsistencies or weak evidence.', team:'Con', durationSec:180, type:'cross-examination' },
      { round:1, id:'con-constructive', name:'Con Constructive', description:'Present counterarguments to Pro\'s claims, supporting with evidence. Address key points and maintain clarity.', team:'Con', durationSec:180, type:'speech' },
      { round:1, id:'cx-by-pro', name:'Cross-Examination', description:'Question Con�s arguments to expose weaknesses. Keep questions precise and relevant.', team:'Pro', durationSec:180, type:'cross-examination' }
    ],
	faqs: [
	  { question: 'What happens during cross-examination?', answer: 'Debaters question each other directly to challenge arguments.' },
	  { question: 'Why is cross-ex important?', answer: 'It exposes weaknesses and clarifies positions.' }
	]
  },

  // 4?? Policy Debate
  {
    id:'policy',
    title:'Policy Debate',
    icon: HiUserGroup,
    sample: 'Plan vs Counterplan',
    description:'Team debate with constructive speeches, cross-examination, and rebuttals; focuses on plan and counterplan.',
    role:'judge',
    roles:{ judge:{ exists:true, can:['updateScores','declareWinner'], fallbackFlowControl:false }, moderator:{ exists:true, can:['startDebate','endTurn','pauseDebate','resumeDebate','skipSpeaker'] } },
    participants:{ min:4,max:4 },
    teams:['Plan','Counterplan'],
    teamsnumber:[2,2],
    spectators:{ canParticipate:false, features:['none'] },
    standardRules:['Constructives ? CX ? Rebuttals ? Summary','CX is timed','Judge scores clash and clarity'],
    roleResponsibilities:['Manage turns','Score interactions'],
    turns:[
      { round:1, id:'1ac', name:'1st Affirmative Constructive', description:'Introduce your plan and advantages clearly, support with evidence. Be persuasive and structured.', team:'Plan', durationSec:480, type:'speech' },
      { round:1, id:'cx-1', name:'CX by Negative', description:'Ask questions to test the Plan case, focusing on logical weaknesses or unsupported claims.', team:'Counterplan', durationSec:180, type:'cross-examination' },
      { round:1, id:'1nc', name:'1st Negative Constructive', description:'Present counterplan or critiques, support with evidence. Be clear and persuasive.', team:'Counterplan', durationSec:480, type:'speech' },
      { round:1, id:'cx-2', name:'CX by Affirmative', description:'Ask targeted questions to test the Counterplan case. Focus on clarity and relevance.', team:'Plan', durationSec:180, type:'cross-examination' },
      { round:1, id:'2ac', name:'2nd Affirmative Constructive', description:'Respond to Counterplan critiques, extend advantages, reinforce case.', team:'Plan', durationSec:480, type:'speech' },
      { round:1, id:'2nc', name:'2nd Negative Constructive', description:'Collapse to key arguments, refute remaining points, summarize case.', team:'Counterplan', durationSec:480, type:'speech' }
    ],
	faqs: [
	  { question: 'What is policy debate about?', answer: 'Debaters propose and defend specific policy changes.' },
	  { question: 'Is evidence required?', answer: 'Yes, extensive research and citations are expected.' }
	]
  },

  // 5?? Public Forum
  {
    id:'pf',
    title:'Public Forum',
    icon: HiBriefcase,
    sample: '2-person teams',
    description:'2v2 debate emphasizing clarity, accessibility, and audience engagement.',
    role:'judge',
    roles:{ judge:{ exists:true, can:['updateScores','declareWinner'], fallbackFlowControl:true }, moderator:{ exists:false, can:['startDebate','endTurn','pauseDebate','resumeDebate','skipSpeaker'] } },
    participants:{ min:4,max:4 },
    teams:['Pro','Con'],
    teamsnumber:[2,2],
    spectators:{ canParticipate:false, features:['comments','questions'] },
    standardRules:['Alternating speeches','Focus on clarity','Judge scores argument strength'],
    roleResponsibilities:['Manage speaking order','Score speeches'],
    turns:[
      { round:1, id:'pro-constructive', name:'Pro Constructive', description:'Present your position clearly with evidence and examples. Persuade the audience and judge.', team:'Pro', durationSec:240, type:'speech' },
      { round:1, id:'con-constructive', name:'Con Constructive', description:'Respond to Pro\'s arguments, provide counterpoints, maintain clarity and logical flow.', team:'Con', durationSec:240, type:'speech' },
      { round:1, id:'pro-rebuttal', name:'Pro Rebuttal', description:'Refute Con points, reinforce main arguments, and aim to persuade.', team:'Pro', durationSec:180, type:'rebuttal' },
      { round:1, id:'con-rebuttal', name:'Con Rebuttal', description:'Counter Pro rebuttals, clarify misunderstandings, strengthen case.', team:'Con', durationSec:180, type:'rebuttal' },
      { round:1, id:'pro-summary', name:'Pro Summary', description:'Summarize main points, highlight strengths, conclude persuasively.', team:'Pro', durationSec:120, type:'reply' },
      { round:1, id:'con-summary', name:'Con Summary', description:'Summarize counterarguments, conclude persuasively.', team:'Con', durationSec:120, type:'reply' }
    ],
	faqs: [
	  { question: 'What is Public Forum debate?', answer: 'A debate format focused on current events and public-friendly arguments.' },
	  { question: 'Is it easy to follow?', answer: 'Yes, arguments are designed to be accessible to general audiences.' }
	]
  },

  // 6?? Parliamentary
  {
    id:'parliamentary',
    title:'Parliamentary Debate',
    icon: HiUsers,
    sample: 'Government vs Opposition (2+ speakers)',
    description:'2+ speakers per team, with constructive and rebuttal speeches; flexible, fast-paced format.',
    role:'judge',
    roles:{ judge:{ exists:true, can:['updateScores','declareWinner'], fallbackFlowControl:false }, moderator:{ exists:true, can:['startDebate','endTurn','pauseDebate','resumeDebate','skipSpeaker', 'approvePOI', 'rejectPOI'] } },
    participants:{ min:4,max:6 },
    teams:['Government','Opposition'],
    teamsnumber:[3,3],
    spectators:{ canParticipate:true, features:['pointsOfInformation'] },
    standardRules:['Each speaker has fixed time','Focus on argument clarity','POIs allowed between speeches'],
    roleResponsibilities:['Track speaker order','Score speeches','Monitor POIs'],
    turns:[
      { round:1, id:'gov-1', name:'First Government', description:'Introduce government case, present 2-3 main arguments with supporting evidence. Be clear and persuasive.', team:'Government', durationSec:480, type:'speech' },
      { round:1, id:'opp-1', name:'First Opposition', description:'Present opposition arguments, countering government points, provide evidence.', team:'Opposition', durationSec:480, type:'speech' },
      { round:1, id:'gov-2', name:'Second Government', description:'Reinforce government arguments, respond to opposition critiques, extend key points.', team:'Government', durationSec:480, type:'speech' },
      { round:1, id:'opp-2', name:'Second Opposition', description:'Address government extensions, refute arguments, strengthen your case.', team:'Opposition', durationSec:480, type:'speech' },
      { round:1, id:'gov-3', name:'Government Summary', description:'Summarize government case, highlight main points, and close persuasively.', team:'Government', durationSec:240, type:'reply' },
      { round:1, id:'opp-3', name:'Opposition Summary', description:'Summarize opposition arguments and conclude persuasively.', team:'Opposition', durationSec:240, type:'reply' }
    ],
	faqs: [
	  { question: 'What are Points of Information?', answer: 'Short questions or interruptions allowed during speeches.' },
	  { question: 'Is preparation required?', answer: 'Topics are often given shortly before the debate.' }
	]
  },

  // 7?? Oxford
  {
    id:'oxford',
    title:'Oxford Debate',
    sample: 'This House believes...',
    icon: HiPresentationChartLine,
    description:'Two teams with opening, argument, and summation rounds; structured and persuasive.',
    role:'moderator',
    roles:{ judge:{ exists:false, can:['updateScores','declareWinner'], fallbackFlowControl:false }, moderator:{ exists:true, can:['startDebate','endTurn','pauseDebate','resumeDebate','skipSpeaker'] } },
    participants:{ min:6,max:6 },
    teams:['Pro','Con'],
    teamsnumber:[3,3],
    spectators:{ canParticipate:true, features:['preVote','postVote','questions'] },
    standardRules:['Structured turns','Each speaker has defined role','Judge scores clarity and impact'],
    roleResponsibilities:['Manage turns','Score speeches'],
    turns:[
      { round:1, id:'pro-1', name:'First Speaker', description:'Introduce your team\'s stance, present key arguments, support with evidence.', team:'Pro', durationSec:300, type:'speech' },
      { round:1, id:'con-1', name:'First Speaker', description:'Present counterarguments and refute Pro points clearly.', team:'Con', durationSec:300, type:'speech' },
      { round:1, id:'pro-2', name:'Second Speaker', description:'Respond to opposition points, reinforce your case, and add new evidence.', team:'Pro', durationSec:300, type:'speech' },
      { round:1, id:'con-2', name:'Second Speaker', description:'Respond to government points, strengthen your case.', team:'Con', durationSec:300, type:'speech' },
      { round:1, id:'pro-3', name:'Third Speaker', description:'Summarize team arguments, highlight strengths, close persuasively.', team:'Pro', durationSec:180, type:'reply' },
      { round:1, id:'con-3', name:'Third Speaker', description:'Summarize opposition case, highlight strengths, and conclude.', team:'Con', durationSec:180, type:'reply' }
    ],
	faqs: [
	  { question: 'How is the winner decided?', answer: 'Audience votes before and after the debate.' },
	  { question: 'Why is it audience-focused?', answer: 'The goal is to persuade public opinion.' }
	]
  },

  // 8?? Mace
  {
    id:'mace',
    title:'Mace Debate',
    sample: '3-per team, no POIs',
    icon: HiChatBubbleBottomCenter,
    description:'Formal debate with 3-member teams and structured constructive and reply speeches.',
    role:'judge',
    roles:{ judge:{ exists:true, can:['updateScores','declareWinner'], fallbackFlowControl:false }, moderator:{ exists:true, can:['startDebate','endTurn','pauseDebate','resumeDebate','skipSpeaker'] } },
    participants:{ min:6,max:6 },
    teams:['A','B'],
    teamsnumber:[3,3],
    spectators:{ canParticipate:false, features:['none'] },
    standardRules:['Structured speeches','Reply speeches conclude debate','Judge scores clarity and logic'],
    roleResponsibilities:['Manage turns','Score speeches'],
    turns:[
      { round:1, id:'teamA-1', name:'First Speaker', description:'Present opening arguments clearly and persuasively.', team:'A', durationSec:480, type:'speech' },
      { round:1, id:'teamB-1', name:'First Speaker', description:'Present opening counterarguments with evidence and clarity.', team:'B', durationSec:480, type:'speech' },
      { round:1, id:'teamA-2', name:'Second Speaker', description:'Rebut opposing points and reinforce team case.', team:'A', durationSec:480, type:'speech' },
      { round:1, id:'teamB-2', name:'Second Speaker', description:'Rebut team A arguments and strengthen your case.', team:'B', durationSec:480, type:'speech' },
      { round:1, id:'teamA-3', name:'Third Speaker', description:'Summarize key arguments and close persuasively.', team:'A', durationSec:240, type:'reply' },
      { round:1, id:'teamB-3', name:'Third Speaker', description:'Summarize key arguments and conclude.', team:'B', durationSec:240, type:'reply' }
    ],
	faqs: [
	  { question: 'What is the Mace format?', answer: 'A structured team debate with defined speaking roles.' },
	  { question: 'What is judged?', answer: 'Clarity, argument strength, and teamwork.' }
	]
  },

  // 9?? Team Debate
  {
    id:'team',
    title:'Team Debate',
    icon: HiMiniRectangleGroup,
    sample: 'Team A vs Team B',
    description:'Debate with 2-3 members per team, constructive speeches and rebuttals.',
    role:'none',
    roles:{ judge:{ exists:true, can:['updateScores','declareWinner'], fallbackFlowControl:true }, moderator:{ exists:false, can:['startDebate','endTurn','pauseDebate','resumeDebate','skipSpeaker'] } },
    participants:{ min:4,max:6 },
    teams:['A','B'],
    teamsnumber:[3,3],
    spectators:{ canParticipate:true, features:['comments'] },
    standardRules:['Structured team speeches','Each speaker has defined role','Judge scores clarity and impact'],
    roleResponsibilities:['Track team turns','Score speeches'],
    turns:[
      { round:1, id:'teamA-1', name:'First Speaker', description:'Introduce team case and main arguments, supported by evidence.', team:'A', durationSec:480, type:'speech' },
      { round:1, id:'teamB-1', name:'First Speaker', description:'Respond to Team A, introduce counterarguments.', team:'B', durationSec:480, type:'speech' },
      { round:1, id:'teamA-2', name:'Second Speaker', description:'Rebut Team B points, extend advantages.', team:'A', durationSec:480, type:'speech' },
      { round:1, id:'teamB-2', name:'Second Speaker', description:'Rebut Team A points, strengthen case.', team:'B', durationSec:480, type:'speech' },
      { round:1, id:'teamA-3', name:'Third Speaker', description:'Summarize team case, highlight key points, close persuasively.', team:'A', durationSec:240, type:'reply' },
      { round:1, id:'teamB-3', name:'Third Speaker', description:'Summarize team case, highlight key points, conclude.', team:'B', durationSec:240, type:'reply' }
    ],
	faqs: [
	  { question: 'How does a team debate work?', answer: 'Teams alternate between arguments and rebuttals, building a collective case.' },
	  { question: 'What roles do speakers have?', answer: 'Speakers introduce arguments, rebut opponents, and deliver summaries.' },
	  { question: 'Why are team debates useful?', answer: 'They develop collaboration, strategy, and structured argumentation.' }
	]
  },

  // 10?? SPAR
  {
    id:'spar',
    title:'SPAR Debate',
    icon: HiUsers,
    sample: 'Quick impromptu 1v1',
    description:'Speedy debate with short timed speeches, emphasizing quick rebuttals.',
    role:'judge',
    roles:{ judge:{ exists:true, can:['updateScores','declareWinner'], fallbackFlowControl:true }, moderator:{ exists:false, can:['startDebate','endTurn','pauseDebate','resumeDebate','skipSpeaker'] } },
    participants:{ min:2,max:2 },
    teams:['Pro','Con'],
    teamsnumber:[1,1],
    spectators:{ canParticipate:false, features:['comment'] },
    standardRules:['Short speeches','Quick rebuttals','Judge scores clarity and impact'],
    roleResponsibilities:['Track rapid turns','Score arguments'],
    turns:[
      { round:1, id:'pro-opening', name:'Pro Constructive', description:'Introduce position, provide main points, be concise and persuasive.', team:'Pro', durationSec:120, type:'speech' },
      { round:1, id:'con-opening', name:'Con Constructive', description:'Respond to Pro points quickly, provide counterarguments.', team:'Con', durationSec:120, type:'speech' },
      { round:1, id:'pro-rebuttal', name:'Pro Rebuttal', description:'Quickly address Con points, reinforce main arguments.', team:'Pro', durationSec:90, type:'rebuttal' },
      { round:1, id:'con-rebuttal', name:'Con Rebuttal', description:'Respond to Pro rebuttals, summarize your case concisely.', team:'Con', durationSec:90, type:'rebuttal' }
    ],
	faqs: [
	  { question: 'What makes SPAR unique?', answer: 'It is fast-paced with minimal prep and spontaneous argumentation.' },
	  { question: 'How long is prep time?', answer: 'Usually 1–2 minutes before speaking begins.' },
	  { question: 'What skills does SPAR develop?', answer: 'Quick thinking, clarity, and concise argument delivery.' }
	]
  },

  // 11?? Forum
  {
    id:'forum',
    title:'Forum Debate',
    sample: 'Open comment-based debate',
    icon: HiChatBubbleLeftRight,
    description:'Open forum style debate where participants can join speaker queue and interact with questions.',
    role:'moderator',
    roles:{ judge:{ exists:false, can:['updateScores','declareWinner'], fallbackFlowControl:false }, moderator:{ exists:true, can:['manageSpectators','startDebate','endTurn', 'approveQuestion', 'rejectQuestion'] } },
    participants:{ min:2,max:10 },
    teams:['Pro','Con'],
    teamsnumber:[5,5],
    spectators:{ canParticipate:true, features:['preVote','postVote','questions','comments'] },
    standardRules:['Speaker queue','Interactive questions','Judge scores argument clarity'],
    roleResponsibilities:['Manage queue','Score arguments'],
    turns:[
      { round:1, id:'pro-1', name:'First Pro. Speaker', description:'Present initial argument with clarity, support with evidence, set context.', team:'Pro', durationSec:300, type:'speech' },
      { round:1, id:'con-1', name:'First Con. Speaker', description:'Counter Pro arguments, provide evidence and structure.', team:'Con', durationSec:300, type:'speech' }
      // additional turns depend on queueing system
    ],
	faqs: [
	  { question: 'Can the audience participate?', answer: 'Yes, through questions and comments.' },
	  { question: 'Is it formal?', answer: 'Less formal than competitive debate formats.' }
	]
  },

  // 12?? Fishbowl
  {
    id:'fishbowl',
    title:'Fishbowl Debate',
	  icon: HiUsers,
    sample: 'Rotating speakers',
    description:'Dynamic discussion with participants entering/exiting active speaker circle; spectators can join discussion in turns.',
    role:'moderator',
    roles:{ judge:{ exists:false, can:['updateScores','declareWinner'], fallbackFlowControl:false }, moderator:{ exists:true, can:['admitSpeaker', 'removeSpeaker','startDebate','endTurn'] } },
    participants:{ min:4,max:12 },
    teams:['Pro','Con'],
    teamsnumber:[6,6],
    spectators:{ canParticipate:true, features:['joinSpeakerQueue','questions','comments'] },
    standardRules:['Active speaker circle','Turned participation','POIs allowed','Judge scores clarity'],
    roleResponsibilities:['Manage active speaker circle','Score arguments'],
    turns:[
      { round:1, id:'fishbowl-1', name:'Initial Speakers', description:'Two participants speak initially. Introduce key arguments and support with evidence.', team:'Pro', durationSec:180, type:'speech' },
      { round:1, id:'fishbowl-2', name:'Opposition Speakers', description:'Two opposition participants respond, provide counterarguments, maintain clarity.', team:'Con', durationSec:180, type:'speech' }
      // additional speakers rotate via queue
    ],
	faqs: [
	  { question: 'What is a fishbowl debate?', answer: 'A rotating discussion where participants join and leave the speaking circle.' },
	  { question: 'Who can speak?', answer: 'Anyone admitted from the queue by the moderator.' }
	]
  },

  // 13?? Town Hall
  {
    id:'townhall',
    title:'Town Hall',
	  icon: HiSpeakerWave,
    sample: 'Audience Q&A debatathon',
    description:'Open discussion format with participants and spectators, emphasizing questions, comments, and POIs.',
    role:'moderator',
    roles:{ judge:{ exists:false, can:['updateScores','declareWinner'], fallbackFlowControl:false }, moderator:{ exists:true, can:['manageSpectators','startDebate','endTurn', 'approveQuestion', 'rejectQuestion', 'updateScores','declareWinner'] } },
    participants:{ min:4,max:20 },
    teams:['Pro','Con'],
    teamsnumber:[10,10],
    spectators:{ canParticipate:true, features:['questions','comments','joinSpeakerQueue'] },
    standardRules:['Active discussion','POIs allowed','Audience interaction encouraged'],
    roleResponsibilities:['Manage speaker queue','Moderate interactions','Score contributions'],
    turns:[
      { round:1, id:'townhall-1', name:'Initial Speakers', description:'Initial two participants present key points and arguments.', team:'Pro', durationSec:180, type:'speech' },
      { round:1, id:'townhall-2', name:'Opposition Speakers', description:'Respond with counterpoints, maintain clarity, and support with evidence.', team:'Con', durationSec:180, type:'speech' }
      // additional speakers rotate via queue
    ],
	faqs: [
	  { question: 'What is a town hall debate?', answer: 'A public discussion where audience members ask questions.' },
	  { question: 'How are questions selected?', answer: 'The moderator chooses which questions are addressed.' }
	]
  }
];

